import React from 'react';
import { Box } from '../../../base/Box/Box';
import * as Accordion from '@radix-ui/react-accordion';
import { Button } from '../../../base/Button/Button';
import { Type } from '../../../base/Type/Type';
import classNames from 'classnames';
import isDarkColour from '../../../utils/isDarkColour';

type Props = {
  colourScheme?: string;
  filterState: object;
  open: string;
  property: string;
};

export const Trigger = ({
  colourScheme,
  filterState,
  open,
  property,
}: Props) => (
  <Accordion.Trigger>
    <Box
      as="div"
      className={classNames(
        'flex items-center justify-between rounded-t-lg w-52 px-4 py-2 border border-ffBlack',
        isDarkColour(colourScheme)
          ? 'bg-ffGreen ff-darkGreen'
          : 'bg-ffLightGrey ff-grey',
        !open && 'rounded-b-lg'
      )}
    >
      <Type
        as="span"
        className={classNames(
          'm-0 p-0 font-foundersGrotesk text-p1 capitalize',
          isDarkColour(colourScheme) ? 'text-white' : 'text-ffBlack'
        )}
      >
        {filterState[property] || 'All'}
      </Type>
      <Button
        type="button"
        variant={!!open ? 'naked-arrow-up' : 'naked-arrow-down'}
      />
    </Box>
  </Accordion.Trigger>
);
